import React, { useEffect, useState } from 'react'
import { Col,Row } from 'react-bootstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect, useDispatch } from 'react-redux'
import moment from 'moment'
import { EMPTY_ARRAY, EMPTY_OBJECT, getSvgIcon } from '../../constants/globalConstants'
// import direction from '../../assets/img/direction.png'
import { convertNumDouble, getConvertedDate, getHoursIndayFormat, getLocation, isPermissionExist, sortPortalPermissionByKey } from '../../utils/helper'
import CONSTANTS from '../../redux/constants'
function UpperHeader(props) {
    const { faciltyData, totalHoursLength, isDirection, screen, paymentData, reservationData, partnerDetails } = props
    const [hours, setHours] = useState('00.00')
    const [formatDt, setFormatDt] = useState(null)
    const localPayment = JSON.parse(localStorage.getItem('paymentRecipt'))
	const [accessPermissions, setAccessPermissions] = useState('')
    const customDispatch = useDispatch()
    // console.log(reservationData.reservation.ticketech_code, 'screen')
   
    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
		setAccessPermissions(getAccessPermissionData)
    }, [EMPTY_ARRAY, partnerDetails])
   
    useEffect(() => {
        const totalhours = isNaN(totalHoursLength) ? Number(totalHoursLength).toFixed(2) : Number(totalHoursLength).toFixed(2)
        let splittedTime = totalhours.split('.')
       
        //show acctual minutes 
        // let minutes = (splittedTime[1]/100)*60
        let minutes = (splittedTime[1])
        if(minutes?.toString()?.includes('.')){
            minutes = minutes?.toString()?.split('.')
            minutes = minutes[0]
        }
        const hours = `${splittedTime[0] == '0' ? '00' : convertNumDouble(splittedTime[0])}:${minutes != 0 ? minutes : '00'}`
        if (screen == 'payment' || screen == 'extend') {
            // setHours(totalhours?.replace('.', ':'))
            let totalhoursData =diff_hours(faciltyData?.checkout_datetime,faciltyData?.check_in_datetime)
            
            setHours(totalhoursData)
            customDispatch({ type: CONSTANTS.UPDATE_SELECTED_HOURS, hours: totalhoursData })
        } else {
            setHours(hours)
            customDispatch({ type: CONSTANTS.UPDATE_SELECTED_HOURS, hours: hours })
        }

    }, [totalHoursLength])
    useEffect(() => {
        if(hours) {
            let dt = getHoursIndayFormat((screen == 'payment' || screen == 'extend') ? Number(hours).toFixed(2) : hours, (screen == 'payment' || screen == 'extend') ? false : true)
            setFormatDt(dt)
        }
    },[hours])

    const diff_hours = (endTime, startTime)=> {
        
        // let start=moment(startTime)?.format('MM/DD/YYYY HH:mm:ss')
        // let end=moment(endTime)?.format('MM/DD/YYYY HH:mm:ss')
        let start = new Date(getConvertedDate(moment(startTime)?.format('YYYY-MM-DD HH:mm:ss'))).getTime()
        let end = new Date(getConvertedDate(moment(endTime)?.add(10, 'seconds')?.format('YYYY-MM-DD HH:mm:ss'))).getTime()
        var diff = moment(end).diff(start, 'seconds')
        var d = Math.floor(diff / (3600*24))
        var h = Math.floor(diff % (3600*24) / 3600)
        var m = Math.floor(diff % 3600 / 60)
        const startDate = new Date(start)
        const endDate = new Date(end)
        // const startDate = new Date(startTime)
        // const endDate = new Date(endTime)
        let timeDiff
        if (!isNaN(startDate) && !isNaN(endDate)) {
        //   const timeDifferenceInMilliseconds = endDate - startDate
        //   const hours = Math.floor((timeDifferenceInMilliseconds/6000 === 0 ? timeDifferenceInMilliseconds : timeDifferenceInMilliseconds + 6000) / 3600000)
        //   const minutes = Math.floor(((timeDifferenceInMilliseconds/6000 === 0 ? timeDifferenceInMilliseconds : timeDifferenceInMilliseconds + 6000) % 3600000) / 60000)
        //   timeDiff=`${hours}.${minutes}`
        //   timeDiff=Number(timeDiff).toFixed(2)
        //   console.log(startTime, endTime, 'timeDiff')
        //   console.log(start, end, 'timeDiff2')

            timeDiff = convertNumDouble((d*24) + h) + '.' + (m<10 ? '0'+(m) : (m))
        } else {
          timeDiff='Invalid Time'
        }
        //setTotalHoursLength(timeDiff)
        // console.log(timeDiff, diff, 'timeDiff')
        return timeDiff
       
      }

    return (
        <Row className='border-top border-bottom g-0'>
            <Col sm={8} xs={8} className='bg-primary p-3 text-white  ' >
                {/* <small>{faciltyData?.facility?.between_streets}</small> */}
                {isPermissionExist(accessPermissions, 'Hide Facility') ? null : isDirection && <a href={getLocation(faciltyData?.facility)} target="_blank" rel="noreferrer"><span className='direction'>{getSvgIcon('share', '#ffffff')}</span></a>}    { /*<img src={direction} alt="Direction" className='direction'/> */}
                <p className='mb-0 header-p'>{faciltyData?.facility?.full_name}</p>
                
                {screen == 'home' ? 
                <h6 className={`${(reservationData?.reservationID || paymentData?.reservation?.ticketech_code || (screen && screen != '' && localPayment?.reservation?.ticketech_code)) ? 'mb-0 ' : ''}mt-0 small header-h6`}>{faciltyData?.facility?.between_streets ? faciltyData?.facility?.between_streets : ''}</h6>
                : 
                <h6 className={`${(reservationData?.reservationID || paymentData?.reservation?.ticketech_code || (screen && screen !== '' && localPayment?.reservation?.ticketech_code)) ? 'mb-0 ' : ''}mt-0 small header-h6`}>{faciltyData?.facility?.entrance_location ? faciltyData?.facility?.entrance_location : 
                `${faciltyData?.facility?.geolocations?.address_1 ? `${faciltyData?.facility?.geolocations?.address_1},` : ''} ${faciltyData?.facility?.geolocations?.city ? `${faciltyData?.facility?.geolocations?.city},` : ''} ${faciltyData?.facility?.geolocations?.state ? faciltyData?.facility?.geolocations?.state : ''}`}</h6>}
                
                {/* {(reservationData?.reservationID || paymentData?.reservation?.ticketech_code || (screen && screen !== '' && localPayment?.reservation?.ticketech_code)) ? <p className='m-0 small'><span className='fw-bold'>Reservation ID:</span> {reservationData?.reservationID ? reservationData.reservation.ticketech_code : paymentData?.reservation?.ticketech_code ? paymentData?.reservation?.ticketech_code : (screen && screen !== '' && localPayment?.reservation?.ticketech_code) ? localPayment?.reservation?.ticketech_code : ''}</p> : ''} */}
                {(reservationData?.reservation || (screen && screen !== '' && localPayment?.reservation?.ticketech_code)) ? <p className='m-0 small'><span className='fw-bold'>Reservation ID:</span> {reservationData?.reservation ? reservationData.reservation.ticketech_code : paymentData?.reservation ? paymentData?.reservation?.ticketech_code : (screen && screen !== '' && localPayment?.reservation?.ticketech_code) ? localPayment?.reservation?.ticketech_code : ''}</p> : ''}
            </Col>
            <Col sm={4} xs={4} className='text-center p-3 text-primary bg-second '>
                <span className='small'>Valid Until</span>
                <h6 className='mb-0 fw-bold'>
                    {faciltyData?.valid_till ? moment(faciltyData?.valid_till)?.format('MM/DD/YYYY') : faciltyData?.checkout_datetime ? moment(faciltyData?.checkout_datetime)?.format('MM/DD/YYYY') : paymentData?.checkout_datetime ? moment(paymentData?.checkout_datetime)?.format('MM/DD/YYYY') : 
                    // moment.utc(new Date()).subtract(4, 'hours').format('hh:mm A')
                    moment(new Date().toLocaleString('en-US',{timeZone: faciltyData?.facility?.timezone || 'America/New_York'})).format('MM/DD/YYYY')
                    }
                </h6>
                <h6 className='mb-0 fw-bold'>
                    {faciltyData?.valid_till ? moment(faciltyData?.valid_till)?.format('hh:mm A') : faciltyData?.checkout_datetime ? moment(faciltyData?.checkout_datetime)?.format('hh:mm A') : paymentData?.checkout_datetime ? moment(paymentData?.checkout_datetime)?.format('hh:mm A') : 
                    // moment.utc(new Date()).subtract(4, 'hours').format('hh:mm A')
                    moment(new Date().toLocaleString('en-US',{timeZone: faciltyData?.facility?.timezone || 'America/New_York'})).format('hh:mm A')
                    }
                </h6>
                {/* <span>{(timeDuration.days > 0 ? timeDuration.days + 'D ' : '') + (timeDuration.hours > 0 ? timeDuration.hours + 'H ' : '') + (timeDuration.minutes > 0 ? timeDuration.minutes + 'M' : '')}</span> */}
                {/* {<span className='small'>{hours ? `${hours} Hours` : '-'}</span>} */}
                <span className='small'>
                    {(formatDt?.day || formatDt?.hour || formatDt?.minute) ? <>
                        {Number(formatDt?.day) > 1 ? <span className='small'>{formatDt?.day} Days </span> : Number(formatDt?.day) > 0 ? <span className='small'>{formatDt?.day} Day </span> : ''}
                        {Number(formatDt?.hour) > 1 ? <span className='small'>{formatDt?.hour} Hrs </span> : Number(formatDt?.hour) > 0 ? <span className='small'>{formatDt?.hour} Hr </span> : ''}
                        {Number(formatDt?.minute) > 1 ? <span className='small'>{formatDt?.minute} Mins</span> : Number(formatDt?.minute) > 0 ? <span className='small'>{formatDt?.minute} Min</span> : ''} </> :
                    '00:00 Hours'}
                </span>
            </Col>
        </Row>
    )
}

UpperHeader.propTypes = {
    dispatch: PropTypes.func,
    faciltyData: PropTypes.object,
    totalHoursLength: PropTypes.string,
    key: PropTypes.string,
    isDirection: PropTypes.bool,
    screen: PropTypes.string,
    paymentData: PropTypes.object,
    reservationData: PropTypes.object,
    partnerDetails: PropTypes.object,
}

UpperHeader.defaulProps = {
    dispatch: noop,
    faciltyData: EMPTY_OBJECT,
    totalHoursLength: EMPTY_OBJECT,
    key: '',
    isDirection: false,
    screen: '',
    paymentData: EMPTY_OBJECT,
    reservationData: EMPTY_OBJECT,
    partnerDetails: EMPTY_OBJECT,
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(UpperHeader)